/* eslint-disable no-param-reassign */
import Chance from 'chance';
import fnList from './functions';
import constants from './constants';

const { arr: constList } = constants;
const dataFaker = new Chance();

export default (app) => {
  // get all functions
  fnList.forEach((f) => {
    app.prototype[`$${f.name}`] = f.fn;
  });
  // get all constants
  constList.forEach((c) => {
    app.prototype[`$${c.name}`] = c.cn;
  });

  app.prototype.$fake = dataFaker;
  // navigation related data
  app.prototype.$navigation = {};
};
/* eslint-enable */
